import React from 'react';
import PropTypes from 'prop-types';
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Image,
  Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { getStaticUrl } from '../../../../../../utils/img';
import MemberCodeCard from './MemberCodeCard';

const MemberCodeSheet = ({ isOpen, onClose, memberCode }) => {
  const { t } = useTranslation();

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      placement="bottom"
      autoFocus={false}
      // Avoid iOS Safari URL bar reflow stuttering the close animation.
      blockScrollOnMount={false}
    >
      <DrawerOverlay />
      <DrawerContent borderTopRadius="6px" data-e2e-id="member-code_modal">
        <DrawerHeader
          sx={{
            height: '44px',
            minHeight: '44px',
            maxHeight: '44px',
            padding: '12px 20px',
            textAlign: 'center',
          }}
        >
          <Text
            variant="sectionTitle"
            className="member-center-profile__section-title-text"
            fontSize="16px"
            lineHeight="20px"
            color="#242833"
          >
            {t('member_profile.member_code.label')}
          </Text>
          <DrawerCloseButton
            top="14px"
            right="20px"
            minWidth="auto"
            minHeight="auto"
            width="16px"
            height="16px"
            backgroundColor="transparent"
            _hover={{ backgroundColor: 'transparent' }}
            _active={{ backgroundColor: 'transparent' }}
            data-e2e-id="member-code-close_button"
          >
            <Image
              src={getStaticUrl('web/v1/img/member_center/close.svg')}
              alt=""
              boxSize="16px"
            />
          </DrawerCloseButton>
        </DrawerHeader>
        <DrawerBody padding="0">
          <MemberCodeCard memberCode={memberCode} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

MemberCodeSheet.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  memberCode: PropTypes.string.isRequired,
};

export default MemberCodeSheet;
